import { punctuateList } from '../utils/stringUtils';

// Used by Rollup Handlebars plugin
// ignore unused exports default
export default function (Handlebars) {
    Handlebars.registerHelper('compare', function (lvalue, operator, rvalue, options) {
        if (arguments.length < 3) {
            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
        }

        if (options === undefined) {
            options = rvalue;
            rvalue = operator;
            operator = '===';
        }

        const operators = {
            '==': function (l, r) {
                return l == r;
            },
            '===': function (l, r) {
                return l === r;
            },
            '!=': function (l, r) {
                return l != r;
            },
            '!==': function (l, r) {
                return l !== r;
            },
            '<': function (l, r) {
                return l < r;
            },
            '>': function (l, r) {
                return l > r;
            },
            '<=': function (l, r) {
                return l <= r;
            },
            '>=': function (l, r) {
                return l >= r;
            },
            '||': function (l, r) {
                return l || r;
            },
            '&&': function (l, r) {
                return l && r;
            },
            hasOwnProperty: function (l, r) {
                return l.hasOwnProperty(r);
            },
            typeof: function (l, r) {
                return typeof l === r;
            },
            nottypeof: function (l, r) {
                return typeof l !== r;
            },
            contains: function (l, r) {
                return l && l.indexOf(r) > -1;
            },
            islast: function (l, r) {
                return l + 1 >= r;
            },
            indexOf: function (l, r) {
                return l.indexOf(r);
            },
            indexOfJSONObject: function (l, r) {
                for (let i = 0; i < l.length; i++) {
                    if (JSON.stringify(l[i]) === JSON.stringify(r)) {
                        return i;
                    }
                }
                return -1;
            },
            containsJSONObject: function (l, r) {
                for (let i = 0; i < l.length; i++) {
                    if (JSON.stringify(l[i]) === JSON.stringify(r)) {
                        return true;
                    }
                }
                return false;
            },
        };

        if (!operators[operator]) {
            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
        }

        const result = operators[operator](lvalue, rvalue);

        if (result) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('replace', function (str, searchString, replaceString) {
        return str.replace(searchString, replaceString);
    });

    Handlebars.registerHelper('removeNonAlphaNumericChars', function (text) {
        return window.removeNonAlphaNumericChars(text);
    });

    Handlebars.registerHelper('escapeQuotes', function (str) {
        return str.replace(/(['"])/g, '\\$1');
    });

    Handlebars.registerHelper('capitalize', function (str) {
        if (!str) {
            return '';
        }
        return str.capitalizeFirstLetter();
    });

    Handlebars.registerHelper('formatCurrency', function (amount, style) {
        if (style === 'ceil') {
            return window.formatCurrency(parseInt(Math.ceil(parseFloat(amount)))).split('.')[0];
        } else {
            const x = parseFloat(amount);
            return window.formatCurrency(x.toFixed(2));
        }
    });

    Handlebars.registerHelper('formatCurrencyLeaveOff0Cents', function (amount) {
        const x = parseFloat(amount);
        return window.formatCurrency(x.toFixed(2), true);
    });

    Handlebars.registerHelper('substring', function (textString, start, end) {
        if (textString.length > end && end > start) {
            return textString.substring(start, end);
        }
        return textString;
    });

    Handlebars.registerHelper('substringPretty', function (textString, start, end) {
        if (textString.length > end && end > start) {
            textString = textString.substring(start, end);
            textString = textString.substring(0, textString.lastIndexOf(' ')) + '...';
        }
        return new Handlebars.SafeString(textString);
    });

    Handlebars.registerHelper('formatDate', function (theDate) {
        const medDate = new Date(theDate);
        return medDate.getMonthName() + ' ' + medDate.getDate() + ', ' + medDate.getFullYear();
    });

    Handlebars.registerHelper('expired', function (expirationDate, options) {
        const now = new Date();
        const year = parseInt(expirationDate.split('-')[0], 10);
        const month = parseInt(expirationDate.split('-')[1], 10) - 1;
        const date = parseInt(expirationDate.split('-')[2], 10);
        const exp = new Date(year, month, date);

        if (now.getTime() > exp.getTime()) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('queryStringParam', function (param, fullURL) {
        if (!param) return '';
        // This check is necessary because fullURL is optional, but Handlebars passes
        // an object as an implicit last param. We only want to use fullURL if it's a string.
        const url = (typeof fullURL === 'string' && fullURL) ? fullURL : location.href;
        const paramValue = window.getURLParam(url, param);
        return (paramValue != null) ? paramValue : '';
    });

    Handlebars.registerHelper('bestQueryStringParam', function (param, param2, fullURL) {
        if (!param && !param2) return '';
        // This check is necessary because fullURL is optional, but Handlebars passes
        // an object as an implicit last param. We only want to use fullURL if it's a string.
        const url = (typeof fullURL === 'string' && fullURL) ? fullURL : location.href;
        const paramValue = window.getURLParam(url, param);
        return (paramValue != null) ? paramValue : window.getURLParam(url, param2);
    });

    /* STATIC VARIABLES */

    Handlebars.registerHelper('baseURL', function () {
        if (typeof baseURL !== 'undefined') {
            return baseURL;
        } else {
            return 'https://www.donorschoose.org/';
        }
    });

    Handlebars.registerHelper('baseCacheURL', function () {
        if (typeof baseCacheURL !== 'undefined') {
            return baseCacheURL;
        } else {
            return 'https://cdn.donorschoose.net/';
        }
    });

    Handlebars.registerHelper('secureBaseURL', function () {
        if (typeof secureBaseURL !== 'undefined') {
            return secureBaseURL;
        } else {
            return 'https://secure.donorschoose.org/';
        }
    });

    Handlebars.registerHelper('locationAndDonorTeacherRelationshipForDonationHistory', function (location, donorTeacherRelationship) {
        return window.proposalMessageFormatter.getLocationAndDonorTeacherRelationship(location, donorTeacherRelationship);
    });

    // For incompletePageMessage
    Handlebars.registerHelper('getPunctuatedTPCFieldErrors', function (fieldErrors) {
        return punctuateList(fieldErrors);
    });

    // For tripItemInCart
    Handlebars.registerHelper('showTripSubtype', function (optionName, itemName, active, options) {
        const showOption = active || itemName == optionName;
        if (showOption) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });
}
